import type { InterventionLite } from "@/entities/intervention";

export const hideInterventionsBatchEditTemplateProperty = (
  interventions?: InterventionLite[]
) => {
  if (!interventions?.length) return true;

  if (interventions.length === 1) return false;

  return !interventions.every(
    (a) =>
      a.intervention_template_id === interventions[0].intervention_template_id
  );
};
